import React from "react";

const Alert = ({ successMessage, errorMessage, isLoading, props }) => {
    return (
        <React.Fragment>
            {successMessage !== false ? (
                <div className="chatbot-alert chatbot-alert-success">
                    {props.messageConnected}
                </div>
            ) : null}

            {errorMessage !== false ? (
                <div className="chatbot-alert chatbot-alert-error">
                    {props.messageConnexionFail}
                </div>
            ) : null}

            {isLoading ? (
                <div className="chatbot-alert chatbot-alert-loading">
                    <div className="loading"></div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default Alert;
